import * as api from '../displaysApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { displaysActionCreators, IDisplayConfig, UpdateDisplayConfig } from '..';
import { DisplaysActionKeys } from '../displaysActionKeys';
import { uiActionCreators } from '../../ui';

function* updateDisplayConfig(action: UpdateDisplayConfig) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IDisplayConfig = yield call(api.updateDisplayConfig, action.payload);

  yield put(displaysActionCreators.setDisplayConfigs([response]));

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateDisplayConfig() {
  yield takeEvery(DisplaysActionKeys.UPDATE_DISPLAY_CONFIG, updateDisplayConfig);
}
